import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Image } from 'react-bootstrap';
import { useAuth } from '../../auth/Auth';
import RoundButton from '../../common/RoundButton';
import svg from '../../../assets/images/Avatar.svg';
import unverifiedPatch from '../../../assets/icon/Bell_ic.svg';
import {
  EDIT_CAPTAIN,
  PARTNER_ADD_EXPERT,
  PARTNER_EDIT_TREEHOUSE
} from '../../../constants/routes.constants';
import '../dashboard/css/kid.management.scss';
import EventEmitter from '../../../utils/events';
import CampUnverifiedModal from '../../common/CampUnverifiedModal';
import CampRestrictModal from './CampRestrictModal';

const SchoolManagement = ({ setCustomizePopup }) => {
  const { school, partner } = useAuth();
  const user = school ? school : partner;
  const history = useHistory();
  const defaultProfileUrl = user && user.picture_url ? user.picture_url : user?.user_type === "school_teacher" ? user?.profile?.picture_url ? user?.profile?.picture_url : svg : svg;
  const [profilePic, setProfilePic] = useState(defaultProfileUrl);
  const [showUnverifiedCampModal, setShowUnverifiedCampModal] = useState(false);
  const [showRestrictCampModal, setShowRestrictCampModal] = useState(false);

  useEffect(() => {
    setProfilePic(defaultProfileUrl);
  }, [defaultProfileUrl]);

  const getUserProfilePic = (image) => {
    setProfilePic(image.preview)
  }

  const partnerBadge = () => {
    switch (user?.user_type) {
      case 'camp master':
        return 'Expert'
      case 'partner':
        return 'Partner'
      case 'school':
        return 'Camp Master'
      case 'school_teacher':
        return 'Camp Captain'
      default:
        break;
    }
  }

  const subscriptionType = () => {
    switch (user?.subcription_type) {
      case 'premium':
        return 'Premium'
      case 'standard':
        return 'Standard'
      default:
        return 'Standard'
    }
  }

  const handleCaptainClick = () => {
    if (school.is_verified) {
      history.push(EDIT_CAPTAIN)
    } else {
      setShowUnverifiedCampModal(true)
    }
  }

  const handlTribeClick = () => {
    if (school.is_verified) {
      history.push(PARTNER_EDIT_TREEHOUSE)
    } else {
      setShowUnverifiedCampModal(true)
    }
  }

  EventEmitter.subscribe('partner_profile_pic', getUserProfilePic)

  return (
    <Row className="middle-section">
      {showRestrictCampModal && <CampRestrictModal showModal={showRestrictCampModal} setShowModal={setShowRestrictCampModal} />}
      <CampUnverifiedModal showModal={showUnverifiedCampModal} setShowModal={setShowUnverifiedCampModal} />
      <Row className="header-row">
        <Col className="welcome">{`Welcome ${user && user.first_name}`}</Col>
        <Col className="add-kid">
          {user?.user_type === "school" ?
            <>
              <RoundButton
                type="button"
                label="Captains"
                className="transparent-button d-sm-block"
                onClick={handleCaptainClick}
              />
              <RoundButton
                type="button"
                label="Tribes"
                className="transparent-button d-sm-block"
                onClick={handlTribeClick}
              />
            </>
            :
            user?.user_type === "partner" ?
              <RoundButton
                type="button"
                label="Add expert"
                className="transparent-button d-sm-block"
                onClick={() => history.push(PARTNER_ADD_EXPERT)}
              />
              : ""
          }
        </Col>
      </Row>
      <Row className="kid-box activated" >
        <Col className="avatar-wrapper">
          <div className="normal-type">
            <div className="avatar-image">
              <Image
                className={`rounded-circle dashboard-kid-avatar`}
                style={{
                  width: '100px',
                  height: '100px',
                  position: "relative",
                  display: "inline-flex"
                }}
                src={profilePic}
              />
              {user && !user.is_verified ?
                <span className={'unverified-patch remove-pointer'}>
                  <Image src={unverifiedPatch} />
                  Unverified
                </span>
                : ""}
            </div>
            <div className="user-info">
              <div className="user-name">{user && user.first_name} {user && user.last_name}</div>
              <div className="full-name">
                {user && user.user_type === "school" ? user.school_name : user.name_of_organisation}
              </div>
              <div style={{display: "flex", gap: "10px"}}>
                <div className={`subscription`}>
                  <span className='current-plan'>
                    {partnerBadge()}
                  </span>
                </div>
                {user && user.user_type === "school" || user.user_type === "school_teacher" ?
                  <div className={`subscription`}>
                    <span className='current-plan' style={{ backgroundColor: '#fcba03' }}>
                      {subscriptionType()}
                    </span>
                  </div>
                  : ''}
              </div>
            </div>
          </div>
        </Col>
        <Col className="command-wrapper">
          <RoundButton
            type="button"
            label="Edit account"
            className="edit-button button"
            onClick={() => setCustomizePopup(true)}
          />
        </Col>
      </Row>
    </Row>
  );
};

export default SchoolManagement;
